import React from 'react';
import Markdown from 'markdown-to-jsx';
import { node, string } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import classnames from 'classnames';
import './MessageBubble.scss';

const MessageBubble = ({ type, children }) => {
  const isBot = type === 'bot';

  const className = classnames({
    'sui-bg-inverse sui-justify-self-end': !isBot,
    'sui-bg-subtle sui-justify-self-start': isBot,
  }, 'sui-flex sui-p-3 sui-mb-1 sui-rounded-lg');

  const spacerClasses = classnames('sui-basis-1/4 sui-grow sui-shrink-0', {
    'sui-order-2': type === 'bot',
  });

  return (
    <div className="sui-flex sui-mb-2">
      <div className={spacerClasses} />
      <div
        className={className}
        role="article"
        aria-label={isBot ? 'Bot Message' : 'User Message'}
      >
        <Typography
          component="div"
          variant="body-base"
          color={isBot ? 'primary' : 'inverse'}
          height={isBot ? 'tight' : 'normal'}
        >
          <div id="maa-message" className="assistant-message-bubble">
            <Markdown>{children.replaceAll(/\n\n/g, '\n\n &nbsp; \n\n')}</Markdown>
          </div>
        </Typography>
      </div>
    </div>
  );
};

MessageBubble.propTypes = {
  children: node.isRequired,
  type: string.isRequired
};

export { MessageBubble };
